import { StatusAnnouncer } from "../shared/components/feedback/status-announcer.js";
import { Container } from "../shared/components/layout/container.js";
import { AudioErrorDialog } from "../shared/skins/shared/audio/error-dialog.js";
import { LivePlaybackHotkeys } from "../shared/skins/shared/live-playback-hotkeys.js";
import { DefaultLiveAudioControls } from "./controls.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-live-audio/skin.tsx
/** @jsxImportSource react */
function DefaultLiveAudioSkin({ children, className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("audio-skin", className),
		"data-theme": "default",
		"data-preset": "live-audio",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(AudioErrorDialog, {}),
			/* @__PURE__ */ jsx(DefaultLiveAudioControls, {}),
			/* @__PURE__ */ jsx(LivePlaybackHotkeys, {}),
			/* @__PURE__ */ jsx(StatusAnnouncer, {})
		]
	});
}
//#endregion
export { DefaultLiveAudioSkin };

//# sourceMappingURL=skin.js.map